export const iconFontAwesomePhotosImagesPanorama = (
	<i className="fa-solid fa-panorama"></i>
);
